<template>
    <div style="
        position: fixed;
        top: 55px;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 111;
        background: rgba(0, 0, 0, 0.8);
      "
    v-if="isOpen">
        <slot>

        </slot>
    </div>
</template>

<script>
  export default {
    name: 'ks-confirm',
    methods:{
        open(){
            this.isOpen = true;
        },
        close(){
            this.isOpen = false;
        }
    },
    data(){
        return {
            isOpen: false
        }
    }
  }
</script>